import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { Link, useHistory } from 'react-router-dom';
import parse from 'html-react-parser';

import FoldersComponent from "../component/folder/FoldersComponent";
import FooterComponent from "../component/footer/FooterComponent";
import HeaderLightComponent from "../component/header/HeaderLightComponent";

import SignedFiles from '../component/svg/SignedFiles';
import SignatureFiles from '../component/svg/SignatureFiles';
import CurrentCases from '../component/svg/CurrentCases';
import AbandonedFiles from '../component/svg/AbandonedFiles';
import Back from '../component/svg/Back';
import AppearanceDropdown, { ListAppearance } from '../component/button/AppearanceDropDown';
import { getFoldersDataViewMode } from '../util/envVariable';
import FoldersListFilters, { FoldersListFiltersValues } from "../component/folder/FoldersListFilters";

interface Params {
  state: string
  currentPage: string
}

const Folder = ({ match }: RouteComponentProps<Params>): JSX.Element => {
  const { t } = useTranslation()
  const history = useHistory()
  const [filters, setFilters] = useState<FoldersListFiltersValues|null>(null);

  const title = match?.params?.state !== undefined ? t(`dashboard.${match.params.state}`) : t('common.folders')
  const userRole = localStorage.getItem('role');
  const previousPage = localStorage.getItem("previousPage") || "/tableau-de-bord";
  const [viewMode, setViewMode] = useState<ListAppearance>(getFoldersDataViewMode());

  const getListClassNames = () => {
    if ('table' === viewMode) {
      return 'box-elevations--anim box-elevations-xl box-elevations--max-heigt-initial no-padding'
    }
    return 'box-elevations box-elevations-xl box-elevations--base box-elevations--max-heigt-initial box-elevations--mb u-mxAuto'
  }

  return (
    <div className="page-layout">
      <HeaderLightComponent />
      {/* 1. Zone Bouton Retour */}
      <div className="wrap u-mxXl">
        <div className="flex-container">
          <div className="col-md-12">
            <Link to="#" onClick={(event) => {
              event.preventDefault();
              history.push(previousPage)
            }}>
              <Back color="var(--ink-1)" />
              <span className="u-txt-size-s u-txt-color-ink-1 u-mxs">{t('button.back')}</span>
            </Link>
          </div>
        </div>
        <div className="flex-container header-step-button-container">
          <div className="col-md-3">
            <Link to={`/dossiers/signed-files`}
              className={`button button-primary button--large button--width-full button--files-state ${match?.params?.state === 'signed-files' ? 'button--files-state--active' : ''}`}>
              <div>{parse(t('dashboard.signed-files'))}</div>
              <SignedFiles color="var(--light)" />
            </Link>
          </div>
          <div className="col-md-3">
            <Link to={`/dossiers/signature-files`}
              className={`button button-primary button--large button--width-full button--files-state ${match?.params?.state === 'signature-files' ? 'button--files-state--active' : ''}`}>
              <div>{parse(t('dashboard.signature-files'))}</div>
              <SignatureFiles color="var(--light)" />
            </Link>
          </div>
          <div className="col-md-3">
            <Link to={`/dossiers/current-cases`}
              className={`button button-primary button--large button--width-full button--files-state ${match?.params?.state === 'current-cases' ? 'button--files-state--active' : ''}`}>
              <div dangerouslySetInnerHTML={{ __html: t('dashboard.current-cases') }} />
              <CurrentCases color="var(--light)" />
            </Link>
          </div>
          <div className="col-md-3">
            <Link to={`/dossiers/abandoned-files`}
              className={`button button-primary button--large button--width-full button--files-state ${match?.params?.state === 'abandoned-files' ? 'button--files-state--active' : ''}`}>
              <div>{parse(t('dashboard.abandoned-files'))}</div>
              <AbandonedFiles color="var(--light)" />
            </Link>
          </div>
        </div>
      </div>

      <main className="wrap u-mxXl u-pv-m">
        {/* 2. En-tête de page (Titre + Filtres) */}
        <div className="flex-container align-middle u-mb-m">

          {/* Colonne Titre */}
          <div className="col-md-4 flex-container no-compensation-xs">
            <h2 className="h3 h3-center">{parse(title)}</h2>
            <AppearanceDropdown currentValue={viewMode} onSelect={setViewMode}/>
          </div>

          {/* Colonne Actions (Filtre + Recherche) */}
          <div className="col-md-8">
            <FoldersListFilters
              userRole={userRole}
              onFiltersChange={setFilters}
            />
          </div>
        </div>

        {/* 3. Contenu Tableau */}
        <div className="min-height-content-folder">
          <div className={getListClassNames()}>
            <FoldersComponent
              filters={filters}
              state={match?.params?.state ?? null}
              viewMode={viewMode}
            />
          </div>
        </div>
      </main>
      <FooterComponent />
    </div>
  );
}

export default Folder;
